module.exports = __webpack_public_path__ + "img/logo-horizontal.38994c94.svg";